export const FooterStyles = {
  mainDiv: {
    display: "flex",
    backgroundImage:
      "radial-gradient(54.35% 54.35% at 13.82% 7%, #162051 0%, #161B32 100%)",
    color: "white",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "26px",
    width: "100%",
  },
  contentDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    width: "70%",
    margin: "auto",
    minHeight: "550px",
  },
  linksColumn: {
    display: "flex",
    justifyContent: "space-between",
    padding: "40px",
  },
  headerText: {
    paddingBottom: "15px",
  },
  listText: {
    paddingBottom: "5px",
  },
  bottomDiv: {
    borderTop: 2,
    borderColor: "white",
  },
  bottomDivContent: {
    display: "flex",
    paddingTop: "35px",
  },
  bottomDivContentText: {
    display: "flex",
    paddingRight: "10px",
  },
};
